import { SimpleGrid } from '@chakra-ui/react';
import { IPayment, PAYMENT_STATUS_DISPLAY } from '@monetize/types/app';
import { formatCurrency, toDateShort } from '@monetize/utils/core';
import { ROUTES } from '../../../constants';
import { PaymentMethodTypeEnumDisplay } from '../../../constants/paymentMethods';
import { MFormFieldReadOnly } from '../MFormFieldReadOnly';
import { LookupTriggerContent } from './LookupTriggerContent';
import { RecordLookupPopover } from './RecordLookupPopover';
import { RecordLookupPopoverHeader } from './RecordLookupPopoverHeader';

export interface PaymentLookupPopoverProps {
  value: string;
  displayLabel?: string;
}

export function PaymentLookupPopover({
  value,
  displayLabel,
}: PaymentLookupPopoverProps) {
  if (!value) {
    return null;
  }
  return (
    <RecordLookupPopover
      recordId={value}
      endpoint={`/api/payments/${value}`}
      buttonProps={{ lineClamp: 3 }}
      renderRecord={(record) => {
        const payment = record as IPayment;
        const recordName = payment.description ?? payment.id ?? value;
        return (
          <>
            <RecordLookupPopoverHeader
              recordId={payment.id}
              href={ROUTES.getAccountPaymentView(
                payment.account.id,
                payment.id,
              )}
              recordName={recordName}
              displayStatus={PAYMENT_STATUS_DISPLAY[payment.paymentStatus]}
            />

            <SimpleGrid columns={2} gap={2} mt={2}>
              <MFormFieldReadOnly label="Payment Date">
                {payment.paymentDate ? toDateShort(payment.paymentDate) : '-'}
              </MFormFieldReadOnly>
              <MFormFieldReadOnly label="Type">
                {PaymentMethodTypeEnumDisplay[payment.paymentType]}
              </MFormFieldReadOnly>
              <MFormFieldReadOnly label="Amount">
                {formatCurrency(payment.amount, { currency: payment.currency })}
              </MFormFieldReadOnly>
              <MFormFieldReadOnly label="Unapplied Amount">
                {payment.unAppliedAmount != null
                  ? formatCurrency(payment.unAppliedAmount, {
                      currency: payment.currency,
                    })
                  : '-'}
              </MFormFieldReadOnly>
              <MFormFieldReadOnly label="Gateway Reference">
                {payment.gatewayReference ?? '-'}
              </MFormFieldReadOnly>
              <MFormFieldReadOnly label="Reference No.">
                {payment.referenceNo ?? '-'}
              </MFormFieldReadOnly>
            </SimpleGrid>
          </>
        );
      }}
    >
      <LookupTriggerContent displayLabel={displayLabel} value={value} />
    </RecordLookupPopover>
  );
}
